import React from 'react';

class FormatButton extends React.Component {
  handleClick = (e) => {
    e.preventDefault();
    // e.stopPropagation()
    if (!this.props.input) return;
    if (this.props.cmd == 'createLink') {
      let url = prompt('Insert url:');
      if (url) document.execCommand('createLink', false, url);
    } else if (this.props.cmd == 'insertImage') {
      let url = prompt('Image url:');
      if (url) document.execCommand(this.props.cmd, false, url);
    } else if (this.props.cmd == 'foreColor') {
      let color = prompt('Hex:');
      if (color[0] !== '#') color = '#' + color;
      document.execCommand('styleWithCSS', false, true);
      document.execCommand(this.props.cmd, false, color);
    } else {
      document.execCommand(this.props.cmd, false);
    }
    this.props.input.focus();
  };

  render() {
    let active = document.queryCommandState(this.props.cmd);
    return (
      <button
        class={
          'btn btn-sm white btn-format mr-2' +
          (active ? ' active' : '') +
          (!this.props.input ? ' disabled' : '')
        }
        onClick={this.handleClick}
      >
        <i class={'fa ' + this.props.icon} />
      </button>
    );
  }
}

export default class FormatButtons extends React.Component {
  exec = (e) => {
    if (!this.props.input) return;
    // console.log("exec",e)
    if (e.target.name) {
      document.execCommand(e.target.name, false, e.target.value);
    } else {
      console.log('exec', e.target.value);
      document.execCommand(e.target.value);
    }

    this.props.input.focus();
  };

  render() {
    let input = this.props.input;
    let block = document.queryCommandValue('formatBlock');
    let justify =
      (document.queryCommandState('justifyLeft') && 'justifyLeft') ||
      (document.queryCommandState('justifyCenter') && 'justifyCenter') ||
      (document.queryCommandState('justifyRight') && 'justifyRight') ||
      (document.queryCommandState('justifyFull') && 'justifyFull');
    return (
      <div>
        <div>
          <select
            class={'form-control form-control-sm mr-2 d-inline-block' + (!input ? ' disabled' : '')}
            style={{ width: 110 }}
            onChange={this.exec}
            name='formatBlock'
            value={block}
          >
            <option value='div'>Normal</option>
            <option value='h6' class='h6'>
              H6
            </option>
            <option value='h5' class='h5'>
              H5
            </option>
            <option value='h4' class='h4'>
              H4
            </option>
            <option value='h3' class='h3'>
              H3
            </option>
            <option value='h2' class='h2'>
              H2
            </option>
            <option value='h1' class='h1'>
              H1
            </option>
          </select>
          <FormatButton cmd='bold' icon='fa-bold' label='bold' input={input} />
          <FormatButton cmd='italic' icon='fa-italic' label='italic' input={input} />
          <FormatButton cmd='underline' icon='fa-underline' label='underline' input={input} />
          <FormatButton
            cmd='strikeThrough'
            icon='fa-strikethrough'
            label='strike through'
            input={input}
          />
          <FormatButton cmd='justifyLeft' icon='fa-align-left' label='left' input={input} />
          <FormatButton cmd='justifyCenter' icon='fa-align-center' label='center' input={input} />
          <FormatButton cmd='justifyRight' icon='fa-align-right' label='right' input={input} />
          <FormatButton cmd='justifyFull' icon='fa-align-justify' label='justify' input={input} />
          <FormatButton
            cmd='insertOrderedList'
            icon='fa-list-ol'
            label='Ordered list'
            input={input}
          />
          <FormatButton
            cmd='insertUnorderedList'
            icon='fa-list-ul'
            label='Unordered list'
            input={input}
          />
          <FormatButton
            cmd='createLink'
            icon='fa-chain'
            label='Link'
            input={input}
            param='prompt'
          />
          <FormatButton
            cmd='insertImage'
            icon='fa-file-image-o'
            label='image'
            input={input}
            param='prompt'
          />
          <FormatButton cmd='undo' icon='fa-undo' label='Undo' input={input} />
          <FormatButton cmd='redo' icon='fa-repeat' label='Redo' input={input} />
          <FormatButton
            cmd='foreColor'
            icon='fa-delicious'
            label='Color'
            input={input}
            color='#f00'
          />
        </div>
      </div>
    );
  }
}
